





















import {Component, Vue, Watch} from "vue-property-decorator";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {CommonStatus} from "@/enums/status";
import {FreightServiceType} from "@/enums/type";
import {assignValueToForm} from "@/shared/services/helper/utils";
import {FreightServiceStore} from "@/modules/freightservices/store";
import debounce from "lodash/debounce";
import {FreightServiceParams} from "@/modules/freightservices/params";
import PostOfficeSelector from "@/shared/components/PostOfficeSelector/index.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";

@Component({
    name: "FreightServiceSearch",
    components: {PostOfficeSelector, EnumSelector}
})
export default class extends mixins(CommonMixin) {
    CommonStatus = CommonStatus;
    FreightServiceType = FreightServiceType;
    form = new FreightServiceParams();

    @Watch('form', { immediate: false, deep: true })
    onValuesChange(val: any) {
        this.handleChange(val);
    }

    handleChange = debounce(function (val) {
        FreightServiceStore.updateFreightServiceParams(val);
        FreightServiceStore.listFreightService({
            params: { ...val, page: 1 }
        })
    }, 500);
}
